import React from 'react';
import useIntl from '../useIntl';
/**
 * React component to format a date
 */
export function FormattedDate(props) {
    var formatDate = useIntl().formatDate;
    return React.createElement(React.Fragment, null, formatDate(props));
}
